import { BaseError } from "./BaseError";

export class ServiceUnavailableError extends BaseError {
  readonly status = 503;
}
